<template>
  <div class="applets-home">
    <el-Scrollbar style="width: 100%;" :native="false">
      <div class="decoration-wrap clearfix">
        <div class="box">
          <h3 class="title">模块选择区域</h3>
          <p class="tips">
            模块选择区可通过选择相应的模块进行拖拽到浏览区域，在浏览区
            选中模块，在模块的右边就会弹出模块编辑页对模块进行排序和编 辑设置。
          </p>
          <div class="modules clearfix">
            <el-Scrollbar style="height: 100%" view-style="height: 100%" :native="false">
              <draggable v-if="decorationMethod == '1'" v-model="componentSelect" v-bind="drag1" style="height: 100%;">
                <transition-group name="flip-list">
                  <div class="component" v-for="item in componentSelect" :key="item.title">
                    <div class="drag">
                      <fragment :is="item.component" />
                    </div>
                    <h3 class="sub-title">
                      {{ item.title }}
                    </h3>
                  </div>
                </transition-group>
              </draggable>
              <draggable v-if="decorationMethod == '2'" v-model="componentSelect1" v-bind="drag1" style="height: 100%;">
                <transition-group name="flip-list">
                  <div class="component" v-for="item in componentSelect1" :key="item.title">
                    <div class="drag">
                      <fragment :is="item.component" />
                    </div>
                    <h3 class="sub-title">
                      {{ item.title }}
                    </h3>
                  </div>
                </transition-group>
              </draggable>
            </el-Scrollbar>
          </div>
        </div>
        <div class="box no-bor">
          <h3 class="title">模块可视化编辑浏览区域</h3>
          <p class="tips">
            该区域是一个可视化编辑的显示区域，鼠标在可视化编辑区域内点
            击对应的模块后，模块的右边就会弹出模块的编辑设置页面，当设
            置好模块数据时，该区域就会显示实时的编辑效果页面。(双击移除模块)
          </p>
          <div class="modules">
            <div class="home-bg__frame">
              <div class="block">
                <el-Scrollbar style="height: 100%" :native="false">
                  <draggable v-bind="drag2" v-model="componentShow" @choose="chooseItem" style="height: 100%;">
                    <div class="component" :style="(decorationMethod == '1') && { marginBottom: 0 }"
                      v-for="item in componentShow" :key="item.title" :data-index="item.index">
                      <div class="drag">
                        <fragment :is="item.component" :ref="`view${item.index}`" />
                      </div>
                    </div>
                  </draggable>
                </el-Scrollbar>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <h3 class="title">模块属性设置区域</h3>
          <p class="tips">
            模块属性设置主要对各模块的图片上传的像素大小，链接，文本内
            容，排序，添加，保存，删除等进行设置。(拖拽排序~！)
          </p>
          <div class="modules">
            <el-Scrollbar style="height: 100%" :native="false">
              <fragment v-if="decorationMethod == '1'">
                <el-collapse v-model="activeName" accordion @change="handleCheck">
                  <el-collapse-item title="轮播banner图模块" name="1">
                    <div class="editor">
                      <draggable v-bind="dragOptions" v-model="home.fileListBanner.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item " v-for="(   item, index   ) in    home.fileListBanner.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListBanner" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required placeholder="请输入链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListBanner.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListBanner.list, 'banner', 8)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度640px，高度384px，支持JPG/PNG格式
                      </p>
                      <el-button v-permission:save="$route.meta.permission" size="98" class="sub-color" @click="
                        moduleSaveData(home.fileListBanner, 'fileListBanner')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="品牌词展示模块" name="2">
                    <div class="editor">
                      <draggable v-bind="dragOptions" v-model="home.fileListBrandCode.list" tag="ul" class="list">
                        <li class="item" v-for="(   item, index   ) in    home.fileListBrandCode.list   " :key="index">
                          <div class="brand-code__input">
                            <el-input type="text" v-model="item.brandCode" placeholder="请输入" required clearable />
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" placeholder="请输入链接地址" required clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListBrandCode.list)" />
                        </li>
                      </draggable>
                      <el-button class="iconfont icon-xinzeng" v-permission:add="$route.meta.permission" @click="
                        moduleAddItem(
                          home.fileListBrandCode.list,
                          'brandCode',
                          4
                        )
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *每一组文本为4-6个字，品牌词只能添加4组文本
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListBrandCode,
                          'fileListBrandCode'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="分类导流模块" name="3">
                    <div class="editor">
                      <draggable v-bind="dragOptions" v-model="home.fileListNav.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item nav" v-for="(   item, index   ) in    home.fileListNav.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListNav" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.name" required clearable placeholder="请输入名称，字数为2-4个字" />
                            <el-input type="text" v-model="item.link" required placeholder="请输入链接地址" clearable />
                          </div>

                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListNav.list)" />
                        </li>
                      </draggable>
                      <el-button class="iconfont icon-xinzeng" v-permission:add="$route.meta.permission"
                        @click="moduleAddItem(home.fileListNav.list, 'nav', 10)">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度48px，高度48px，支持PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission"
                        @click="moduleSaveData(home.fileListNav, 'fileListNav')">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="人气推荐模块" name="4">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListhotRec.title" type="text" required placeholder="请输入标题"
                          clearable />
                        <el-input v-model="home.fileListhotRec.ad" type="text" required placeholder="请输入广告语" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListhotRec.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item hot " v-for="(   item, index   ) in    home.fileListhotRec.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListhotRec" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListhotRec.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListhotRec.list, 'banner', 8)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度640px，高度384px，支持JPG/PNG格式
                      </p>
                      <el-button v-permission:save="$route.meta.permission" size="98" class="sub-color" @click="
                        moduleSaveData(home.fileListhotRec, 'fileListhotRec')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="拼团模块" name="5">
                    <div class="editor">
                      <fragment v-for="(   item, index   ) in    home.fileListGroup.list   " :key="index">
                        <p class="ad">
                          <span class="caption">标题</span>
                          <el-input class="txt" v-model="item.title" type="text" required placeholder="请输入标题" clearable />
                          <el-input v-model="item.ad" type="text" required placeholder="请输入广告语" clearable />
                        </p>
                        <draggable v-bind="dragOptions" v-model="item.list" @choose="setItemIndex" tag="ul" class="list">
                          <li class="item group" v-for="(   sItem, sIndex   ) in    item.list   " :key="sIndex">
                            <div class="img">
                              <el-upload class="BannerUpload" ref="fileListGroup" action="/" accept=".jpg,.jpeg,.png"
                                :on-change="_handleAddItemData.bind(null, sItem)
                                  " :on-remove="_handleRemove.bind(null, sItem)" :http-request="_appendFormDataInfo.bind(null, sItem)
    " :file-list="sItem.img" list-type="picture-card" :drag="true" :auto-upload="false">
                                <i class="el-icon-plus" />
                              </el-upload>
                            </div>
                            <div class="input">
                              <el-input type="text" v-model="sItem.link" required @change="val => {
                                searchGoods(val, sItem)
                              }
                                " placeholder="请输入链接地址" clearable />
                            </div>
                            <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu" @click="
                              delItem(home.fileListGroup.list, 'group', index)
                              " />
                          </li>
                        </draggable>
                      </fragment>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListGroup.list, 'group', 4)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *长图宽度1000px,高度1237px,横图宽度1000px,高度606px
                      </p>
                      <el-button size="98" v-permission:save="$route.meta.permission" class="sub-color" @click="
                        moduleSaveData(home.fileListGroup, 'fileListGroup')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="新品模块" name="6">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListNewProduct.title" type="text" required
                          placeholder="请输入标题" clearable />
                        <el-input v-model="home.fileListNewProduct.ad" type="text" required placeholder="请输入广告语"
                          clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListNewProduct.list" @choose="setItemIndex"
                        tag="ul" class="list">
                        <li class="item new " v-for="(   item, index   ) in    home.fileListNewProduct.list   "
                          :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListNewProduct" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListNewProduct.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(
                          home.fileListNewProduct.list,
                          'newProduct',
                          8
                        )
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListNewProduct,
                          'fileListNewProduct'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="产地产区模块" name="7">
                    <div class="editor">
                      <fragment v-for="(   item, index   ) in    home.fileListProducing.list   " :key="index">
                        <div class="sub-banner">
                          <el-upload class="BannerUpload" ref="fileListProducing" action="/" accept=".jpg,.jpeg,.png"
                            :on-change="_handleAddItemData.bind(null, item.subBanner)
                              " :on-remove="_handleRemove.bind(null, item.subBanner)
    " :http-request="_appendFormDataInfo.bind(null, item.subBanner)
    " :file-list="item.subBanner.img" list-type="picture-card" :drag="true" :auto-upload="false">
                            <i class="el-icon-plus" />
                          </el-upload>
                        </div>
                        <p class="tips">
                          *图片宽度600px，高度200px，支持JPG/PNG格式
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu" @click="
                            delItem(
                              home.fileListProducing.list,
                              'producing',
                              index
                            )
                            " />
                        </p>
                        <div class="category-nav">
                          <ul class="category">
                            <li class="sub-item" v-for="(   sItem, sIndex   ) in    item.category   " :key="sIndex"
                              @click="changeData(sIndex, index)" :class="activeIndex[`cur${index}`] === sIndex &&
                                'active'
                                ">
                              <p class="num">0{{ sIndex + 1 }}</p>
                              <el-input v-model="sItem.input" type="text" required @change="val => {
                                searchGoods(val, sItem)
                              }
                                " placeholder="请输入" clearable />
                            </li>
                          </ul>
                        </div>
                        <draggable v-show="activeIndex[`cur${index}`] === 0" v-bind="dragOptions"
                          v-model="item.category[0].list" @choose="setItemIndex" tag="ul" class="list">
                          <li class="item new " v-for="(   sItem, sIndex   ) in    item.category[0].list   "
                            :key="sIndex">
                            <div class="img">
                              <el-upload class="BannerUpload" ref="fileListProducing" action="/" accept=".jpg,.jpeg,.png"
                                :on-change="_handleAddItemData.bind(null, sItem)
                                  " :on-remove="_handleRemove.bind(null, sItem)" :http-request="_appendFormDataInfo.bind(null, sItem)
    " :file-list="sItem.img" list-type="picture-card" :drag="true" :auto-upload="false">
                                <i class="el-icon-plus" />
                              </el-upload>
                            </div>
                            <div class="input">
                              <el-input type="text" v-model="sItem.link" required @change="val => {
                                searchGoods(val, sItem)
                              }
                                " placeholder="请输入商品ID/链接地址" clearable />
                            </div>
                          </li>
                        </draggable>
                        <draggable v-show="activeIndex[`cur${index}`] === 1" v-bind="dragOptions"
                          v-model="item.category[1].list" @choose="setItemIndex" tag="ul" class="list">
                          <li class="item new " v-for="(   sItem, sIndex   ) in    item.category[1].list   "
                            :key="sIndex">
                            <div class="img">
                              <el-upload class="BannerUpload" ref="fileListProducing" action="/" accept=".jpg,.jpeg,.png"
                                :on-change="_handleAddItemData.bind(null, sItem)
                                  " :on-remove="_handleRemove.bind(null, sItem)" :http-request="_appendFormDataInfo.bind(null, sItem)
    " :file-list="sItem.img" list-type="picture-card" :drag="true" :auto-upload="false">
                                <i class="el-icon-plus" />
                              </el-upload>
                            </div>
                            <div class="input">
                              <el-input type="text" v-model="sItem.link" required @change="val => {
                                searchGoods(val, sItem)
                              }
                                " placeholder="请输入商品ID/链接地址" clearable />
                            </div>
                          </li>
                        </draggable>
                        <draggable v-show="activeIndex[`cur${index}`] === 2" v-bind="dragOptions"
                          v-model="item.category[2].list" @choose="setItemIndex" tag="ul" class="list">
                          <li class="item new " v-for="(   sItem, sIndex   ) in    item.category[2].list   "
                            :key="sIndex">
                            <div class="img">
                              <el-upload class="BannerUpload" ref="fileListProducing" action="/" accept=".jpg,.jpeg,.png"
                                :on-change="_handleAddItemData.bind(null, sItem)
                                  " :on-remove="_handleRemove.bind(null, sItem)" :http-request="_appendFormDataInfo.bind(null, sItem)
    " :file-list="sItem.img" list-type="picture-card" :drag="true" :auto-upload="false">
                                <i class="el-icon-plus" />
                              </el-upload>
                            </div>
                            <div class="input">
                              <el-input type="text" v-model="sItem.link" required @change="val => {
                                searchGoods(val, sItem)
                              }
                                " placeholder="请输入商品ID/链接地址" clearable />
                            </div>
                          </li>
                        </draggable>
                      </fragment>
                      <el-button class="iconfont icon-xinzeng" v-permission:add="$route.meta.permission" @click="
                        moduleAddItem(
                          home.fileListProducing.list,
                          'producing',
                          3
                        )
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListProducing,
                          'fileListProducing'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="酒庄推荐模块" name="8">
                    <div class="editor">
                      <draggable v-bind="dragOptions" v-model="home.fileListWineryRec.list" @choose="setItemIndex"
                        tag="ul" class="list">
                        <li class="item winery " v-for="(   item, index   ) in    home.fileListWineryRec.list   "
                          :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListWineryRec" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.discount" required placeholder="折扣" clearable
                              class="discount" />
                            <el-input type="text" v-model="item.name" required placeholder="酒庄名称" clearable
                              class="name" />
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入链接地址" clearable class="link" />
                            <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                              @click="delItem(home.fileListWineryRec.list)" />
                          </div>
                        </li>
                      </draggable>

                      <el-button class="iconfont icon-xinzeng" v-permission:add="$route.meta.permission" @click="
                        moduleAddItem(
                          home.fileListWineryRec.list,
                          'wineryRec',
                          4
                        )
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度600px，高度300px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListWineryRec,
                          'fileListWineryRec'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="线下支持模块" name="9">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListSupport.title" type="text" required
                          placeholder="请输入广告语" clearable />
                        <el-input v-model="home.fileListSupport.ad" type="text" required placeholder="请输入广告语" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListSupport.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item winery support " v-for="(   item, index   ) in    home.fileListSupport.list   "
                          :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListSupport" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.name" required placeholder="请输入名称" clearable
                              class="name" />
                            <el-input type="text" v-model="item.link" required placeholder="请输入链接地址" clearable
                              class="link" />
                            <el-input type="text" v-model="item.intro" required placeholder="简短介绍" clearable
                              class="intro" />
                            <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                              @click="delItem(home.fileListSupport.list)" />
                          </div>
                        </li>
                      </draggable>
                      <el-button class="iconfont icon-xinzeng" v-permission:add="$route.meta.permission" @click="
                        moduleAddItem(home.fileListSupport.list, 'support', 6)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度600px，高度300px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListSupport,
                          'fileListSupport'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="开机广告模块" name="10">
                    <div class="editor">
                      <draggable v-bind="dragOptions" v-model="home.fileListAd.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item Ad" v-for="(   item, index   ) in    home.fileListAd.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListAd" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required placeholder="请输入链接地址" clearable
                              class="intro" />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListAd.list)" />
                        </li>
                      </draggable>
                      <el-button class="iconfont icon-xinzeng" v-permission:add="$route.meta.permission" @click="
                        moduleAddItem(home.fileListAd.list, 'banner', 6)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度750px，高度1355px，支持JPG/PNG格式
                      </p>

                      <div class="ad-time__select">
                        <span class="intro el-icon-time">广告时长</span>
                        <el-slider v-model="home.fileListAd.adTime" :max="60" :marks="marks" @change="handlerTimer"
                          tooltip-class="ad-tips" :format-tooltip="formatTooltip" />
                      </div>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission"
                        @click="moduleSaveData(home.fileListAd, 'fileListAd')">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </fragment>
              <fragment v-else>
                <el-collapse v-model="activeName" accordion @change="handleCheck">
                  <el-collapse-item title="轮播banner图模块" name="1">
                    <div class="editor">
                      <draggable v-bind="dragOptions" v-model="home.fileListBanner.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item " v-for="(   item, index   ) in    home.fileListBanner.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListBanner" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required placeholder="请输入链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListBanner.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListBanner.list, 'banner', 8)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度640px，高度384px，支持JPG/PNG格式
                      </p>
                      <el-button v-permission:save="$route.meta.permission" size="98" class="sub-color" @click="
                        moduleSaveData(home.fileListBanner, 'fileListBanner')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="品牌词展示模块" name="2">
                    <div class="editor">
                      <draggable v-bind="dragOptions" v-model="home.fileListBrandCode.list" tag="ul" class="list">
                        <li class="item" v-for="(   item, index   ) in    home.fileListBrandCode.list   " :key="index">
                          <div class="brand-code__input">
                            <el-input type="text" v-model="item.brandCode" placeholder="请输入" required clearable />
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" placeholder="请输入链接地址" required clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListBrandCode.list)" />
                        </li>
                      </draggable>
                      <el-button class="iconfont icon-xinzeng" v-permission:add="$route.meta.permission" @click="
                        moduleAddItem(
                          home.fileListBrandCode.list,
                          'brandCode',
                          4
                        )
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *每一组文本为4-6个字，品牌词只能添加4组文本
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListBrandCode,
                          'fileListBrandCode'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="酒加精选" name="3">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListSelected.title" type="text" required
                          placeholder="请输入标题" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListSelected.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item new" v-for="(   item, index   ) in    home.fileListSelected.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListSelected" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListSelected.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListSelected.list, 'group2', 3)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListSelected,
                          'fileListSelected'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="人气推荐" name="4">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListhotRec.title" type="text" required placeholder="请输入标题"
                          clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListhotRec.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item new" v-for="(   item, index   ) in    home.fileListhotRec.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListhotRec" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListhotRec.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListhotRec.list, 'group2', 4)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(home.fileListhotRec, 'fileListhotRec')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="新品首发" name="6">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListNewProduct.title" type="text" required
                          placeholder="请输入标题" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListNewProduct.list" @choose="setItemIndex"
                        tag="ul" class="list">
                        <li class="item new" v-for="(   item, index   ) in    home.fileListNewProduct.list   "
                          :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListLimit" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" @change="val => {
                              searchGoods(val, item)
                            }
                              " required placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListNewProduct.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(
                          home.fileListNewProduct.list,
                          'group2',
                          4
                        )
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListNewProduct,
                          'fileListNewProduct'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="更多美酒" name="7">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListMoreProduct.title" type="text" required
                          placeholder="请输入标题" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListMoreProduct.list" @choose="setItemIndex"
                        tag="ul" class="list">
                        <li class="item new" v-for="(   item, index   ) in    home.fileListMoreProduct.list   "
                          :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListMoreProduct" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListMoreProduct.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(
                          home.fileListMoreProduct.list,
                          'group2',
                          4
                        )
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(
                          home.fileListMoreProduct,
                          'fileListMoreProduct'
                        )
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="价格" name="8">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" v-model="home.fileListPrice.title" type="text" required disabled
                          placeholder="请输入标题" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListPrice.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item new" v-for="(   item, index   ) in    home.fileListPrice.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListSelected" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListPrice.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListPrice.list, 'group2', 3)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(home.fileListPrice, 'fileListPrice')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="名庄" name="9">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" disabled v-model="home.fileListManor.title" type="text" required
                          placeholder="请输入标题" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListManor.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item new" v-for="(   item, index   ) in    home.fileListManor.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListSelected" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListManor.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListManor.list, 'group2', 3)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(home.fileListManor, 'fileListManor')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="产地" name="10">
                    <div class="editor">
                      <p class="ad">
                        <span class="caption">标题</span>
                        <el-input class="txt" disabled v-model="home.fileListArea.title" type="text" required
                          placeholder="请输入标题" clearable />
                      </p>
                      <draggable v-bind="dragOptions" v-model="home.fileListArea.list" @choose="setItemIndex" tag="ul"
                        class="list">
                        <li class="item new" v-for="(   item, index   ) in    home.fileListArea.list   " :key="index">
                          <div class="img">
                            <el-upload class="BannerUpload" ref="fileListSelected" action="/" accept=".jpg,.jpeg,.png"
                              :on-change="_handleAddItemData.bind(null, item)" :on-remove="_handleRemove.bind(null, item)"
                              :http-request="_appendFormDataInfo.bind(null, item)
                                " :file-list="item.img" list-type="picture-card" :drag="true" :auto-upload="false">
                              <i class="el-icon-plus" />
                            </el-upload>
                          </div>
                          <div class="input">
                            <el-input type="text" v-model="item.link" required @change="val => {
                              searchGoods(val, item)
                            }
                              " placeholder="请输入商品ID/链接地址" clearable />
                          </div>
                          <i v-permission:del="$route.meta.permission" class="iconfont icon-shanchu"
                            @click="delItem(home.fileListArea.list)" />
                        </li>
                      </draggable>
                      <el-button v-permission:add="$route.meta.permission" class="iconfont icon-xinzeng" @click="
                        moduleAddItem(home.fileListArea.list, 'group2', 3)
                        ">
                        添加
                      </el-button>
                      <p class="tips">
                        *图片宽度1000px，高度1000px，支持JPG/PNG格式
                      </p>
                      <el-button size="98" class="sub-color" v-permission:save="$route.meta.permission" @click="
                        moduleSaveData(home.fileListArea, 'fileListArea')
                        ">
                        保存
                      </el-button>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </fragment>
            </el-Scrollbar>
          </div>
        </div>
      </div>
    </el-Scrollbar>
  </div>
</template>
<script>
import components from 'components/scanDecorationComponents.js'
import decorationAppMxins from '../../Mixins/'

export default {
  name: 'AppletsHome',
  mixins: [decorationAppMxins],
  props: {
    home: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isMyMerchant: {
      type: Boolean
    },
    decorationMethod: {
      type: String
    },
    appletsId: {
      type: String
    },
    renovationType: {
      type: String
    },
    renovationName: {
      type: String
    }
  },
  data() {
    // 模块选择排序
    let componentClassify, compSelect, componentClassify1, compSelect1
    //if (this.decorationMethod == '1') {
    componentClassify = [
      'Banner1',
      'BrandCode1',
      'Nav1',
      'Hot1',
      'BlockColor',
      'Group1',
      'New1',
      'Producing1',
      'Winery1',
      'Support1',
      'Ad1'
    ]
    compSelect = [
      {
        component: '',
        title: '01轮播banner图模块',
        index: '1',
        props: 'fileListBanner'
      },
      {
        component: '',
        title: '02品牌词展示模块',
        index: '2',
        props: 'fileListBrandCode'
      },
      {
        component: '',
        title: '03分类导流模块',
        index: '3',
        props: 'fileListNav'
      },
      {
        component: '',
        title: '04人气推荐模块',
        index: '4',
        props: 'fileListhotRec'
      },
      {
        component: '',
        title: '05色块模块',
        index: '-1'
      },
      {
        component: '',
        title: '06拼团模块',
        index: '5',
        props: 'fileListGroup'
      },
      {
        component: '',
        title: '07新品模块',
        index: '6',
        props: 'fileListNewProduct'
      },
      {
        component: '',
        title: '08产地产区模块',
        index: '7',
        props: 'fileListProducing'
      },
      {
        component: '',
        title: '09酒庄推荐模块',
        index: '8',
        props: 'fileListWineryRec'
      },
      {
        component: '',
        title: '10线下支持模块',
        index: '9',
        props: 'fileListSupport'
      },
      {
        component: '',
        title: '11开机广告模块',
        index: '10',
        props: 'fileListAd'
      }
    ]
    //} else {
    componentClassify1 = [
      'Banner1',
      'BrandCode1',
      'Group2',
      'BlockColor',
      'Hot2',
      'Limit',
      'New2',
      'Hot2',
      'Group2',
      'Group2',
      'Group2'
    ]
    compSelect1 = [
      {
        component: '',
        title: '01轮播banner图模块',
        index: '1',
        props: 'fileListBanner'
      },
      {
        component: '',
        title: '02品牌词展示模块',
        index: '2',
        props: 'fileListBrandCode'
      },
      {
        component: '',
        title: '03酒加精选',
        index: '3',
        props: 'fileListSelected'
      },
      {
        component: '',
        title: '04色块模块',
        index: '-1'
      },
      {
        component: '',
        title: '05人气推荐',
        index: '4',
        props: 'fileListhotRec'
      },
      {
        component: '',
        title: '06限量购',
        index: '5',
        props: 'fileListLimit'
      },
      {
        component: '',
        title: '07新品首发',
        index: '6',
        props: 'fileListNewProduct'
      },
      {
        component: '',
        title: '08更多美酒',
        index: '7',
        props: 'fileListMoreProduct'
      },
      {
        component: '',
        title: '09价格',
        index: '8',
        props: 'fileListPrice'
      },
      {
        component: '',
        title: '10名庄',
        index: '9',
        props: 'fileListManor'
      },
      {
        component: '',
        title: '11产地',
        index: '10',
        props: 'fileListArea'
      }
    ]
    // }
    componentClassify.forEach((v, i) => {
      components.forEach(vm => {
        if (vm[v] !== undefined) {
          compSelect[i].component = vm[v]
        }
      })
    })
    componentClassify1.forEach((v, i) => {
      components.forEach(vm => {
        if (vm[v] !== undefined) {
          compSelect1[i].component = vm[v]
        }
      })
    })
    return {
      activeIndex: {
        cur0: 0,
        cur1: 0,
        cur2: 0
      },
      componentSelect: compSelect,
      componentSelect1: compSelect1
    }
  },
  methods: {
    /**
     * 广告时间toolTip格式化
     * @param val
     * @returns {string}
     */
    formatTooltip(val) {
      return `${val}s`
    },
    /**
     * 切换产区产地数据
     * @param sIndex
     * @param index
     */
    changeData(sIndex, index) {
      this.activeIndex[`cur${index}`] = sIndex
      const child = this.$refs[`view${this.activeName}`]
      if (child)
        child[0]._updateData(this.home.fileListProducing, index, sIndex)
    },
    /**
     * 启动组件的定时器
     */
    handlerTimer() {
      const child = this.$refs[`view${this.activeName}`]
      if (child) child[0]._startTimer()
    },
    /**
     * 搜索商品
     * @param val
     * @param item
     */
    searchGoods(val, item) {
      const isNmber = /[0-9]/.test(val)
      if (isNmber) {
        this.api
          .searchGoods({
            applet_id: this.appletsId,
            goods_id: val
          })
          .then(res => {
            if (res.goods_list.length > 0) {
              const {
                goods_id,
                goods_name,
                goods_en,
                goods_image,
                spec_list,
                goods_jingle
              } = res.goods_list[0]
              Object.assign(item, {
                link: goods_id,
                img: [
                  {
                    url: goods_image
                  }
                ],
                imgUrl: goods_image,
                goods_name,
                goods_en,
                goods_jingle,
                goods_price: spec_list[0] && spec_list[0].goods_price
              })
            } else {
              this.$notify({
                message: '暂无此商品~！',
                type: 'warning'
              })
            }
          })
      }
    }
  }
}
</script>
